import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, onSnapshot, updateDoc, deleteDoc, doc, query, orderBy, getCountFromServer, limit, getDocs } from 'firebase/firestore';
import { db } from '../LoginComp/firebase';

import jsPDF from 'jspdf';
import "./community.css";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import {
  BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend,
  PieChart, Pie, Cell,
  LineChart, Line
} from "recharts";
import html2canvas from "html2canvas";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];

const ADMIN_PASSWORD = "EyeCare@932"; 

function AdminPanelCommunity() {
  // ============ STATE VARIABLES ============
  const [activeSubMenu, setActiveSubMenu] = useState('createVoucher');
  const [vouchers, setVouchers] = useState([]);
  const [editingVoucher, setEditingVoucher] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nextVoucherNumber, setNextVoucherNumber] = useState('00181');
  const navigate = useNavigate();

  // Password modal states
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [pendingDate, setPendingDate] = useState("");
  const [pendingAction, setPendingAction] = useState(null); // "edit" | "delete" | "date"
  const [pendingVoucher, setPendingVoucher] = useState(null);

const [projects, setProjects] = useState([]);
const [projectData, setProjectData] = useState({ name: "" });
const [selectedProject, setSelectedProject] = useState("");

  // Filter states
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    year: "",
    month: "",
    branch: "",
    paymentMethod: "",
    project: "",
    voucherNumber: "",
  });

  // Form state - CHANGED: 'vendor' to 'name' to match database field
  const [formData, setFormData] = useState({
    branch: 'Maradana',
    name: '', 
    project: '', 
    description: '',
    amount: '',
    typeOfExpenses: '',
    paymentMethod: 'Cash',
    chequeNumber: '',
    depositNumber: '',
    date: new Date().toISOString().split('T')[0],
    preparedBy: '',
    authorizedBy: ''
  });

  // Vendor management states
  const [vendorData, setVendorData] = useState({
    name: "",
    company: "",
    phone: "",
    email: "",
    address: ""
  });
  const [vendors, setVendors] = useState([]);
  const [editingVendorId, setEditingVendorId] = useState(null);
  const [vendorSearch, setVendorSearch] = useState("");
  const [showVendorList, setShowVendorList] = useState(false);

  // ============ FILTER HANDLER ============
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  // ============ VOUCHER NUMBER LOGIC ============
  // Get the next voucher number (based on the highest existing voucherNumber)
  useEffect(() => {
    const getNextVoucherNumber = async () => {
      try {
        const q = query(
          collection(db, "community_vouchers"),
          orderBy("voucherNumber", "desc"),
          limit(1)
        );
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const lastVoucher = snapshot.docs[0].data();
          const nextNumber = (parseInt(lastVoucher.voucherNumber, 10) + 1)
            .toString()
            .padStart(3, "0");
          setNextVoucherNumber(nextNumber);
        } else {
          setNextVoucherNumber("00181"); // first voucher
        }
      } catch (error) {
        console.error("Error getting next voucher number:", error);
        setNextVoucherNumber("00181");
      }
    };

    getNextVoucherNumber();
  }, [vouchers]);

  // ============ LOAD VOUCHERS FROM FIRESTORE ============
  useEffect(() => {
    setLoading(true);
    const q = query(collection(db, 'community_vouchers'), orderBy('createdAt', 'desc'));
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const vouchersData = [];
      querySnapshot.forEach((doc) => {
        vouchersData.push({ id: doc.id, ...doc.data() });
      });
      setVouchers(vouchersData);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching vouchers:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // ============ FORM HANDLERS ============
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      project: '', 
      branch: 'Maradana',
      description: '',
      amount: '',
      typeOfExpenses: '',
      paymentMethod: 'Cash',
      date: new Date().toISOString().split('T')[0],
      preparedBy: '',
      authorizedBy: '',
      name: '' // Added name field to reset
    });
    setEditingVoucher(null);
  };

  // ============ VOUCHER SUBMIT HANDLER ============
  const handleSubmit = async (e) => {

  e.preventDefault();

  // 🚨 HARD LOCK (prevents multiple clicks)
  if (loading) return;

  if (!formData.name) {
    alert("Please select a Vendor first.");
    return;
  }

  setLoading(true);

  try {
    let voucherNumber;

    if (editingVoucher) {
      voucherNumber = editingVoucher.voucherNumber;
    } else {
      voucherNumber = nextVoucherNumber;
    }

    let voucherData = {
      ...formData,
      voucherNumber,
      createdAt: editingVoucher ? editingVoucher.createdAt : new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };

    if (editingVoucher) {
      await updateDoc(doc(db, "community_vouchers", editingVoucher.id), voucherData);
    } else {
      const docRef = await addDoc(collection(db, "community_vouchers"), voucherData);
      voucherData.id = docRef.id;

      // Generate PDF
      generatePDF(voucherData);

      // Increase voucher number
      setNextVoucherNumber(
        (parseInt(voucherNumber, 10) + 1).toString().padStart(3, "0")
      );
    }

    resetForm();

    setActiveSubMenu("viewVouchers");
    setTimeout(() => setActiveSubMenu("createVoucher"), 500);

  } catch (error) {
    console.error("Error saving voucher:", error);
  }

  setLoading(false);
};


  // ============ PDF GENERATION ============
  const generatePDF = (voucher) => {
    // Create A5 landscape document (210 x 148 mm)
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a5'
    });
    
    // Add background for header
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 210, 25, 'F');
    
    // Add logo (assuming it's in the public folder)
    try {
      // This would work if we were in a browser environment with the image available
      // For now, we'll use text as a fallback
      doc.addImage('/optical-logo.png', 'PNG', 15, 3, 20, 20);
    } catch (e) {
      // If image fails to load, use text logo
      doc.setFontSize(16);
      doc.setTextColor(255, 255, 255);
      doc.text("◆", 20, 12);
    }
    
    // Add company name
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.text("Community Eye Care Services", 105, 12, { align: 'center' });
    
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text("No. 932, Maradana Road, Colombo 08", 105, 18, { align: 'center' });
    doc.text("Tel: 011 7700 904 / 011 7700 906", 105, 24, { align: 'center' });
   
    // Divider line
    doc.setDrawColor(200, 200, 200);
    doc.line(15, 45, 195, 45);
    
    // Voucher details - FIXED: using voucher.name instead of voucher.vendor
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Name: ${voucher.name}`, 20, 50); // Changed from voucher.vendor to voucher.name
    doc.text(`Voucher Number: ${voucher.voucherNumber}`, 20, 55);
    doc.text(`Branch: ${voucher.branch}`, 80, 55);
    doc.text(`Date: ${voucher.date}`, 120, 55);
    doc.text(`Type Of Expenses: ${voucher.typeOfExpenses}`, 120, 62);

    // Payment Method with extra info
    let paymentDetails = `Payment Method: ${voucher.paymentMethod}`;
    if (voucher.paymentMethod === "Cheque" && voucher.chequeNumber) {
      paymentDetails += ` (No: ${voucher.chequeNumber})`;
    }
    if (voucher.paymentMethod === "Direct Deposit" && voucher.depositNumber) {
      paymentDetails += ` (No: ${voucher.depositNumber})`;
    }

    doc.text(paymentDetails, 20, 62);
    
    // Table header
    doc.setFillColor(240, 240, 240);
    doc.rect(15, 70, 180, 8, 'F');
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Description", 20, 75);
    doc.text("Amount (Rs.)", 160, 75, { align: 'right' });
    
    // Table content - Handle long descriptions with auto-wrap
    doc.setFont("helvetica", "normal");
    
    // Split description into multiple lines if it's too long
    const maxDescriptionWidth = 120; // Maximum width for description column in mm
    const descriptionLines = doc.splitTextToSize(voucher.description, maxDescriptionWidth);
    
    // Calculate starting Y position for description
    let descriptionY = 85;
    const lineHeight = 5; // Approximate line height in mm
    
    // Draw description as multiple lines if needed
    doc.text(descriptionLines, 20, descriptionY);
    
    // Calculate the height of the description block
    const descriptionHeight = descriptionLines.length * lineHeight;
    
    // Position amount vertically aligned with the description
    const amountY = descriptionLines.length > 1 
      ? descriptionY + (descriptionHeight / 2) - 2  // Center for multi-line
      : descriptionY;  // Normal position for single line
    
    doc.text(parseFloat(voucher.amount).toLocaleString('en-US', { 
      minimumFractionDigits: 2 
    }), 160, amountY, { align: 'right' });
    
    // Adjust total row position based on description height
    const totalStartY = Math.max(95, descriptionY + descriptionHeight + 5);
    
    // Total row
    doc.setDrawColor(200, 200, 200);
    doc.line(15, totalStartY, 195, totalStartY);
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Total Amount", 20, totalStartY + 7);
    doc.text(`Rs. ${parseFloat(voucher.amount).toLocaleString('en-US', { 
      minimumFractionDigits: 2 
    })}`, 160, totalStartY + 7, { align: 'right' });
    
    // Adjust signatures section position
    const signaturesY = totalStartY + 15;
    
    // Signatures section
    doc.setDrawColor(200, 200, 200);
    doc.line(15, signaturesY, 195, signaturesY);
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Prepared By", 40, signaturesY + 10);
    doc.text("Recieved By", 140, signaturesY + 10);
    
    doc.setFont("helvetica", "normal");
    doc.text(voucher.preparedBy, 40, signaturesY + 18);
    doc.text(voucher.authorizedBy, 140, signaturesY + 18);
    
    // Signature lines
    doc.setDrawColor(100, 100, 100);
    doc.line(30, signaturesY + 22, 80, signaturesY + 22);
    doc.line(130, signaturesY + 22, 180, signaturesY + 22);
    
    // Adjust footer position
    const footerY = signaturesY + 30;
    
    // Footer - only show if there's enough space
    if (footerY < 140) { // 140mm is near the bottom of A5 landscape
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text("Thank you for your business!", 105, footerY, { align: 'center' });
    }
    
    // Save the PDF
    doc.save(`voucher_${voucher.voucherNumber}.pdf`);
  };

  // ============ CHART FUNCTIONS ============
  const downloadChartAsPDF = (id, filename) => {
    const chartElement = document.getElementById(id);
    if (!chartElement) return;
    html2canvas(chartElement).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "mm", "a4");
      const imgWidth = 280;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save(filename);
    });
  };

  // ============ VOUCHER ACTION HANDLERS ============
  // Edit voucher (open modal)
  const handleEditRequest = (voucher) => {
    setPendingAction("edit");
    setPendingVoucher(voucher);
    setShowPasswordModal(true);
  };

  // Delete voucher (open modal)
  const handleDeleteRequest = (voucher) => {
    setPendingAction("delete");
    setPendingVoucher(voucher);
    setShowPasswordModal(true);
  };

  // ============ LOGOUT ============
  const handleLogout = () => {
    navigate('/');
  };




useEffect(() => {
  const fetchProjects = async () => {
    const snapshot = await getDocs(collection(db, "projects"));
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setProjects(list);
  };

  fetchProjects();
}, []);



const saveProject = async () => {
  if (!projectData.name) return alert("Project name required");

  await addDoc(collection(db, "projects"), {
    name: projectData.name,
    createdAt: new Date()
  });

  setProjectData({ name: "" });

  // refresh
  const snapshot = await getDocs(collection(db, "projects"));
  setProjects(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
};







  // ============ FILTERED VOUCHERS ============
// const filteredVouchers = vouchers.filter((v) => {

//   if (!v.date) return false;

//   const voucherDate = new Date(v.date);
//   const voucherYear = voucherDate.getFullYear().toString();
//   const voucherMonth = (voucherDate.getMonth() + 1).toString().padStart(2, "0");

//   return (
//     (!filters.year || filters.year === voucherYear) &&
//     (!filters.month || filters.month === voucherMonth) &&
//     (!filters.branch || filters.branch === v.branch) &&
//     (!filters.paymentMethod || filters.paymentMethod === v.paymentMethod) &&
//     (!filters.name || 
//       v.name?.toLowerCase().includes(filters.name.toLowerCase()))
//   );

// });


// const filteredVouchers = vouchers.filter((v) => {
//   const voucherDate = new Date(v.date);
//   const voucherYear = voucherDate.getFullYear().toString();
//   const voucherMonth = (voucherDate.getMonth() + 1).toString().padStart(2, "0");

//   const projectValue = v.project || "NO_PROJECT";

//   return (
//     (!filters.year || filters.year === voucherYear) &&
//     (!filters.month || filters.month === voucherMonth) &&
//     (!filters.paymentMethod || filters.paymentMethod === v.paymentMethod) &&
//     (!filters.name || filters.name === v.name) &&
//     (!filters.project || filters.project === projectValue) // 👈 THIS LINE
//   );
// });

const filteredVouchers = vouchers.filter((v) => {
  const voucherDate = new Date(v.date);
  const voucherYear = voucherDate.getFullYear().toString();
  const voucherMonth = (voucherDate.getMonth() + 1)
    .toString()
    .padStart(2, "0");

  const projectValue = v.project || "NO_PROJECT";

  return (
    (!filters.year || filters.year === voucherYear) &&
    (!filters.month || filters.month === voucherMonth) &&
    (!filters.paymentMethod || filters.paymentMethod === v.paymentMethod) &&
    (!filters.name || filters.name === v.name) &&
    (!filters.project || filters.project === projectValue) &&
    (!filters.voucherNumber ||
      v.voucherNumber
        ?.toString()
        .toLowerCase()
        .includes(filters.voucherNumber.toLowerCase()))
  );
});










  // ============ VENDOR MANAGEMENT FUNCTIONS ============
  const fetchVendors = async () => {
    const querySnapshot = await getDocs(collection(db, "vendors"));

    const vendorList = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setVendors(vendorList);
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  const saveVendor = async () => {
    if (!vendorData.name) {
      alert("Vendor name required");
      return;
    }

    try {
      if (editingVendorId) {
        const vendorRef = doc(db, "vendors", editingVendorId);
        await updateDoc(vendorRef, vendorData);
        setEditingVendorId(null);
      } else {
        await addDoc(collection(db, "vendors"), {
          ...vendorData,
          createdAt: new Date()
        });
      }

      setVendorData({
        name: "",
        company: "",
        phone: "",
        email: "",
        address: ""
      });

      fetchVendors();
    } catch (error) {
      console.error("Error saving vendor:", error);
    }
  };

  const deleteVendor = async (id) => {
    const confirmDelete = window.confirm("Delete this vendor?");
    if (!confirmDelete) return;
    await deleteDoc(doc(db, "vendors", id));
    fetchVendors();
  };

  const editVendor = (vendor) => {
    setVendorData({
      name: vendor.name,
      company: vendor.company,
      phone: vendor.phone,
      email: vendor.email,
      address: vendor.address
    });
    setEditingVendorId(vendor.id);
  };





  useEffect(() => {
    const loadVendors = async () => {
      const querySnapshot = await getDocs(collection(db, "vendors"));
      const vendorList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setVendors(vendorList);
    };
    loadVendors();
  }, []);




const handleFilterChangeVender = (e) => {
  setFilters({
    ...filters,
    [e.target.name]: e.target.value
  });
};



  // ============ EXPORT TO EXCEL ============
  // const exportToExcel = () => {
  //   if (!vouchers || vouchers.length === 0) return;

  //   // Map vouchers into desired column order
  //   const formattedData = vouchers.map(v => ({
  //     "Date": v.date, 
  //     "Voucher Number": v.voucherNumber,
  //     "Branch": v.branch,
  //     "Type Of Expenses": v.typeOfExpenses,
  //     "description": v.description,
  //     "Amount (Rs.)": v.amount,
  //     "Payment Method": v.paymentMethod,
  //     "Cheque Number": v.chequeNumber,
  //   }));

  //   // Create worksheet
  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);

  //   // Create workbook
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Vouchers");

  //   // Export
  //   XLSX.writeFile(workbook, "Vouchers.xlsx");
  // };
const exportToExcel = () => {
  const dataToExport = filteredVouchers; // 👈 IMPORTANT CHANGE

  if (!dataToExport || dataToExport.length === 0) {
    alert("No filtered data to export!");
    return;
  }

  const formattedData = dataToExport.map(v => ({
    "Date": v.date,
    "Voucher Number": v.voucherNumber,
    "Vendor": v.name,
    "Branch": v.branch,
    "Type Of Expenses": v.typeOfExpenses,
    "Description": v.description,
    "Amount (Rs.)": v.amount,
    "Payment Method": v.paymentMethod,
    "Cheque Number": v.chequeNumber,
    "Project": v.project || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Vouchers");

  XLSX.writeFile(workbook, "Community_Vouchers.xlsx");
};









const groupedByProject = {};

filteredVouchers.forEach(v => {
  const key = v.project || "NO_PROJECT";

  if (!groupedByProject[key]) {
    groupedByProject[key] = {
      total: 0,
      vouchers: []
    };
  }

  groupedByProject[key].total += parseFloat(v.amount || 0);
  groupedByProject[key].vouchers.push(v);
});














  // ============ RENDER FUNCTIONS (ALL ORIGINAL JSX) ============

  // Render Create Voucher Section
  const renderCreateVoucher = () => {
const isVendorSelected = formData.name && formData.name.trim() !== "";

    return (
      <div className="content-section">
        <h2>{editingVoucher ? 'Edit Voucher' : 'Create Voucher'}</h2>



      <div className="input-group">
        <label>Project (Optional)</label>
        <select
          name="project"
          value={formData.project}
          onChange={handleInputChange}
        >
          <option value="">-- No Project --</option>
          {projects.map(p => (
            <option key={p.id} value={p.name}>
              {p.name}
            </option>
          ))}
        </select>
      </div>



        <div className="input-group">
          <label>Vendor *</label>
          <input
            type="text"
            placeholder="Search vendor..."
            value={formData.name || vendorSearch}
            onChange={(e) => {
              setVendorSearch(e.target.value);
              setShowVendorList(true);
            }}
            onFocus={() => setShowVendorList(true)}
          />

          {showVendorList && (
            <div className="vendor-dropdown">
              {vendors
                .filter(v =>
                  v.name?.toLowerCase().includes(vendorSearch.toLowerCase())
                )
                .map((vendor) => (
                  <div
                    key={vendor.id}
                    className="vendor-option"
                    onClick={() => {
                      setFormData((prev) => ({
                        ...prev,
                        name: vendor.name
                      }));

                      setVendorSearch(vendor.name);
                      setShowVendorList(false);
                    }}
                  >
                    {vendor.name} {vendor.company && `- ${vendor.company}`}
                  </div>
                ))}
            </div>
          )}
          </div>



        <div className="voucher-number-display">
          Voucher Number: {editingVoucher ? editingVoucher.voucherNumber : nextVoucherNumber}
        </div>
        
        <form className="form-container" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="input-group">
              <label>Branch *</label>
              <select 
                name="branch"
                value={formData.branch}
                onChange={handleInputChange}
                required
              >
                <option value="Colombo 08">Colombo 08</option>
                <option value="Colombo 07">Colombo 07</option>
                <option value="Maradana">Maradana</option>
                <option value="Moratuwa">Moratuwa</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="input-group">
              <label>Description *</label>
              <input 
                type="text" 
                name="description"
                placeholder="Enter description" 
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </div>
            
            <div className="input-group">
              <label>Amount (Rs.) *</label>
              <input 
                type="number" 
                name="amount"
                placeholder="Enter amount" 
                value={formData.amount}
                onChange={handleInputChange}
                required
                step="0.01"
                min="0"
              />
            </div>

            <div className="input-group">
              <label>Type Of Expenses *</label>
              <select
                name="typeOfExpenses"
                value={formData.typeOfExpenses}
                onChange={handleInputChange}
                required
              >


          
                <option value="">-- Select Expense Type --</option>
                <option value="Accesories Payments">Accesories Payments</option>
                 <option value="Accounting Fee">Accounting Fee</option>
                <option value="Building Renovation">Building Renovation</option>
                <option value="Consultation">Consultation</option>
                <option value="Construction Payment">Construction Works</option>
                <option value="CBuilding Rent">Building Rent</option>
                <option value="Orthoptic consultation">Orthoptic consultation</option>
                <option value="Cash Withdrawal">Cash Withdrawal</option>
                <option value="Courier & Postages">Courier & Postages</option>
                <option value="Electricity-Maradana">Electricity-Maradana</option>
                <option value="Electricity-Eye Care Optical">Electricity-Eye Care Optical</option>
                <option value="Fittings">Fittings</option>
                <option value="Foods & Meals">Foods & Meals</option>
                <option value="Income Tax Payment">Income Tax Payment</option>
                <option value="Loan">Loan</option>
                <option value="Printing & Stationary">Printing & Stationary</option>
                <option value="Promotion">Promotion</option>
                <option value="Rent-Maradana">Rent-Maradana</option>
                <option value="Rent-Optical">Rent-Optical</option>
                <option value="Repair & Maintanance">Repair & Maintanance</option>
                <option value="Salaries & Wages">Salaries & Wages</option>
                <option value="Suppliers Payment">Suppliers Payment</option>
                <option value="Scholarship Expense">Scholarship Expense</option>
                <option value="Telephone Bill">Telephone Bill</option>
                <option value="Telephone Bill-Moratuwa">Telephone Bill - Colombo 08</option>
                <option value="Telephone Bill-Moratuwa">Telephone Bill - Moratuwa</option>
                <option value="Traveling & Transport">Traveling & Transport</option>
                <option value="Water Bill">Water Bill</option>
                <option value="Others">Others</option>
              </select>
            </div>
          </div>
          
          <div className="form-row">
            <div className="input-group">
              <label>Payment Method *</label>
              <select
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleInputChange}
                required
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="Cheque">Cheque</option>
                <option value="Direct Deposit">Direct Deposit</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {formData.paymentMethod === "Cheque" && (
              <div className="input-group">
                <label>Cheque Number *</label>
                <input
                  type="text"
                  name="chequeNumber"
                  value={formData.chequeNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
            )}

            {formData.paymentMethod === "Direct Deposit" && (
              <div className="input-group">
                <label>Deposit Number *</label>
                <input
                  type="text"
                  name="depositNumber"
                  value={formData.depositNumber}
                  onChange={handleInputChange}
                  required
                />
              </div>
            )}

            <div className="input-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={(e) => {
                  const today = new Date().toISOString().split("T")[0];
                  if (e.target.value < today) {
                    setPendingAction("date");
                    setPendingDate(e.target.value);
                    setShowPasswordModal(true);
                    return;
                  }
                  handleInputChange(e); // normal case
                }}
                required 
              />
            </div>
          </div>

          <div className="form-row">
            <div className="input-group">
              <label>Prepared By *</label>
              <input 
                type="text" 
                name="preparedBy"
                placeholder="Enter name" 
                value={formData.preparedBy}
                onChange={handleInputChange}
              />
            </div>
            <div className="input-group">
              <label>Recieved By *</label>
              <input 
                type="text" 
                name="authorizedBy"
                placeholder="Enter name" 
                value={formData.authorizedBy}
                onChange={handleInputChange}
              />
            </div>
          </div>




          
<div className="form-buttons">
<button
  type="submit"
  className="submit-btn"
  disabled={loading || !isVendorSelected}
>
  {loading
    ? "Saving..."
    : editingVoucher
    ? "Update Voucher"
    : "Create Voucher & Download PDF"}
</button>

  {editingVoucher && (
    <button
      type="button"
      className="cancel-btn"
      onClick={resetForm}
      disabled={loading}
    >
      Cancel Edit
    </button>
  )}
</div>


        </form>
      </div>
    );
  };




  // Render View Vouchers Section
  const renderViewVouchers = () => {
    return (
      <div className="content-section">
        <h2>View All Vouchers</h2>

        {/* Filter Section */}
        <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
          <i className="fas fa-filter"></i> {showFilters ? "Hide Filters" : "Show Filters"}
        </button>

        {showFilters && (
          <div className="filter-section">

<input
  type="text"
  name="voucherNumber"
  placeholder="Search Voucher Number"
  value={filters.voucherNumber}
  onChange={handleFilterChange}
/>


            <select name="year" value={filters.year} onChange={handleFilterChange}>
              <option value="">All Years</option>
              {Array.from({ length: 10 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return <option key={year} value={year}>{year}</option>;
              })}
            </select>

            <select name="month" value={filters.month} onChange={handleFilterChange}>
              <option value="">All Months</option>
              {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m,i) => (
                <option key={i} value={m}>{new Date(0, i).toLocaleString('default',{month:'long'})}</option>
              ))}
            </select>

            <select name="branch" value={filters.branch} onChange={handleFilterChange}>
              <option value="">All Branches</option>
              <option value="Colombo 08">Colombo 08</option>
              <option value="Colombo 07">Colombo 07</option>
              <option value="Maradana">Maradana</option>
              <option value="Moratuwa">Moratuwa</option>
              <option value="Other">Other</option>
            </select>




<select name="name" value={filters.name} onChange={handleFilterChange}>
  <option value="">All Vendors</option>

  {vendors.map((vendor) => (
    <option key={vendor.id} value={vendor.name}>
      {vendor.name} {vendor.company && `- ${vendor.company}`}
    </option>
  ))}

</select>

<select name="project" value={filters.project} onChange={handleFilterChange}>
  <option value="">All Projects</option>
  <option value="NO_PROJECT">No Project</option>
  {projects.map((p) => (
    <option key={p.id} value={p.name}>
      {p.name}
    </option>
  ))}
</select>


            <select name="paymentMethod" value={filters.paymentMethod} onChange={handleFilterChange}>
              <option value="">All Methods</option>
              <option value="Cash">Cash</option>
              <option value="Card">Card</option>
              <option value="Cheque">Cheque</option>
              <option value="Direct Deposit">Direct Deposit</option>
              <option value="Other">Other</option>
            </select>

            {/* Reset Button */}
            <button
              className="reset-btn"
              onClick={() =>
                setFilters({
                  year: "",
                  month: "",
                  branch: "",
                  paymentMethod: "",
                  name: "",
                  project: "",
                  voucherNumber: "",

                })
              }
            >
              <i className="fas fa-undo"></i> Reset Filters
            </button>

            <button className="export-btn" onClick={exportToExcel}>
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
        )}

        {loading ? (
          <p>Loading vouchers...</p>
        ) : vouchers.length === 0 ? (
          <p>No vouchers found. Create your first voucher.</p>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Vendor</th> {/* Added back Vendor column */}
                  <th>Voucher Number</th>
                  <th>Branch</th>
                  <th>Description</th>
                  <th>Amount (Rs.)</th>
                  <th>Date</th>
                  <th>Payment Method</th>
                  <th>Cheque Number</th>
                  <th>Actions</th>
                </tr>
              </thead>


              <tbody>
                {filteredVouchers.map((voucher) => (
                  <tr key={voucher.id}>
                    <td>{voucher.name}</td>
                    <td className="voucher-number">{voucher.voucherNumber}</td>
                    <td>{voucher.branch}</td>
                    <td>{voucher.description}</td>
                    <td className="amount">
                      {parseFloat(voucher.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                    </td>
                    <td>{voucher.date}</td>
                    <td>{voucher.paymentMethod}</td>
                    <td>{voucher.chequeNumber}</td>
                    <td>
                      <div className="action-buttons">
                        <button 
                          className="action-btn edit-btn"
                          onClick={() => handleEditRequest(voucher)}
                        >
                          <i className="fas fa-edit"></i> Edit
                        </button>

                        <button 
                          className="action-btn delete-btn"
                          onClick={() => handleDeleteRequest(voucher)}
                        >
                          <i className="fas fa-trash"></i> Delete
                        </button>

                        <button 
                          className="action-btn download-btn"
                          onClick={() => generatePDF(voucher)}
                        >
                          <i className="fas fa-download"></i> PDF
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>




            </table>
          </div>
        )}
      </div>
    );
  };

  // Render Analysis Section
  const renderAnalysis = () => {
    // Group vouchers by month-year → then group by type
    const monthlyTypeData = {};
    vouchers.forEach((v) => {
      const d = new Date(v.date);
      const month = d.toLocaleString("default", { month: "short" });
      const year = d.getFullYear();
      const key = `${month}-${year}`;

      if (!monthlyTypeData[key]) monthlyTypeData[key] = {};
      monthlyTypeData[key][v.typeOfExpenses] =
        (monthlyTypeData[key][v.typeOfExpenses] || 0) + parseFloat(v.amount || 0);
    });

    // Convert to chart-friendly format
    const monthlyPieCharts = Object.entries(monthlyTypeData).map(([monthYear, types]) => {
      const pieData = Object.entries(types).map(([name, value]) => ({
        name,
        value,
      }));
      return { monthYear, pieData };
    });

    // Yearly Line chart (same as before)
    const yearlyData = {};
    vouchers.forEach((v) => {
      const d = new Date(v.date);
      const year = d.getFullYear();
      yearlyData[year] = (yearlyData[year] || 0) + parseFloat(v.amount || 0);
    });
    const yearlyChartData = Object.entries(yearlyData).map(([y, amt]) => ({
      year: y,
      amount: amt,
    }));

    return (
      <div className="content-section">
        <h2>Analysis Report</h2>

        {/* Month-wise Pie Charts */}
        {monthlyPieCharts.map(({ monthYear, pieData }, idx) => (
          <details key={idx} className="month-section" open={idx === monthlyPieCharts.length - 1}>
            <summary className="month-title">{monthYear} Expenses by Type</summary>
            <div id={`pieChart-${monthYear}`} style={{ textAlign: "center", marginBottom: "20px" }}>
              <PieChart width={700} height={400}>
                <Pie
                  data={pieData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={150}
                  fill="#8884d8"
                  label
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
              <button
                onClick={() => downloadChartAsPDF(`pieChart-${monthYear}`, `${monthYear}-expenses.pdf`)}
              >
                Download PDF
              </button>
            </div>
          </details>
        ))}

        {/* Yearly Line Chart */}
        <div id="yearlyChart" style={{ textAlign: "center", marginTop: "30px" }}>
          <h3>Yearly Expenses Trend</h3>
          <LineChart width={700} height={300} data={yearlyChartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="amount" stroke="#82ca9d" />
          </LineChart>
          <button
            onClick={() => downloadChartAsPDF("yearlyChart", "yearly-expenses.pdf")}
          >
            Download PDF
          </button>
        </div>
      </div>
    );
  };

  // Render Add Vendor Section
  const renderAddVendor = () => {
    return (
      <div className="vendor-main-container">
        {/* TOP - ADD VENDOR */}
        <div className="add-vendor-container">
          <h2>{editingVendorId ? "Edit Vendor" : "Add Vendor"}</h2>
          <div className="vendor-form">
            <input
              type="text"
              placeholder="Vendor Name"
              value={vendorData.name}
              onChange={(e)=>setVendorData({...vendorData, name:e.target.value})}
            />
            <input
              type="text"
              placeholder="Company"
              value={vendorData.company}
              onChange={(e)=>setVendorData({...vendorData, company:e.target.value})}
            />
            <input
              type="text"
              placeholder="Phone"
              value={vendorData.phone}
              onChange={(e)=>setVendorData({...vendorData, phone:e.target.value})}
            />
            <input
              type="email"
              placeholder="Email"
              value={vendorData.email}
              onChange={(e)=>setVendorData({...vendorData, email:e.target.value})}
            />
            <textarea
              placeholder="Address"
              value={vendorData.address}
              onChange={(e)=>setVendorData({...vendorData, address:e.target.value})}
            />
            <button className="save-vendor-btn" onClick={saveVendor}>
              {editingVendorId ? "Update Vendor" : "Save Vendor"}
            </button>
          </div>
        </div>

        {/* BOTTOM - VENDOR LIST */}
        <div className="vendor-list-container">
          <h3>All Vendors</h3>
          <div className="vendor-scroll-list">
            {vendors.map((vendor)=>(
              <div key={vendor.id} className="vendor-card">
                <div className="vendor-info">
                  <b>{vendor.name}</b>
                  <p>{vendor.company}</p>
                  <p>{vendor.phone}</p>
                  <p>{vendor.email}</p>
                  <p>{vendor.address}</p>
                </div>
                <div className="vendor-actions">
                  <button
                    className="edit-btn"
                    onClick={()=>editVendor(vendor)}
                  >
                    Edit
                  </button>
                   <button
                    className="delete-btn"
                    onClick={()=>deleteVendor(vendor.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };



const renderAddProject = () => (
 <div className="add-project-container">
  <h2>Add Project</h2>

  <input
    type="text"
    placeholder="Enter Project Name"
    value={projectData.name}
    onChange={(e) => setProjectData({ name: e.target.value })}
  />

  <button className="save-project-btn" onClick={saveProject}>
    Add Project
  </button>

  <div className="project-list">
    <h3>All Projects</h3>

    {projects.map((p) => (
      <div key={p.id} className="project-item">
        <span className="project-name">{p.name}</span>

      </div>
    ))}
  </div>
</div>
);




  // Render Welcome Section
  const renderWelcome = () => {
    return (
      <div className="content-section welcome">
        <h2>Welcome to Community Eye Care Services Admin Panel</h2>
        <p>Select an option from the sidebar to manage vouchers.</p>
      </div>
    );
  };

  // ============ MAIN RENDER ============
  return (
    <div className="admin-panel-institute">
      <div className="top-nav">
        <div className="nav-buttons">

        <button 
          className={activeSubMenu === 'addProject' ? 'active' : ''}
          onClick={() => setActiveSubMenu('addProject')}
        >
          Add Project
        </button>

          <button 
            className={activeSubMenu === 'addVendor' ? 'active' : ''}
            onClick={() => setActiveSubMenu('addVendor')} >
            <i className="fas fa-plus-circle"></i> Add Vendor 
          </button>

          <button 
            className={activeSubMenu === 'createVoucher' ? 'active' : ''}
            onClick={() => setActiveSubMenu('createVoucher')}
          >
            <i className="fas fa-plus-circle"></i> Create Voucher - Community Eye Care
          </button>
          <button 
            className={activeSubMenu === 'viewVouchers' ? 'active' : ''}
            onClick={() => setActiveSubMenu('viewVouchers')}
          >
            <i className="fas fa-list"></i> View All Vouchers
          </button>
          <button 
            className={activeSubMenu === 'analysis' ? 'active' : ''}
            onClick={() => setActiveSubMenu('analysis')}
          >
            <i className="fas fa-list"></i> Analysis Report
          </button>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i> Logout
        </button>

        {showPasswordModal && (
          <div className="modal-overlay">
            <div className="modal-box">
              <h3>Enter Admin Password</h3>
              <input
                type="password"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                placeholder="Password"
              />
              <div className="modal-actions">
                <button
                  onClick={async () => {
                    if (passwordInput === ADMIN_PASSWORD) {
                      if (pendingAction === "date") {
                        handleInputChange({ target: { name: "date", value: pendingDate } });
                      } else if (pendingAction === "edit" && pendingVoucher) {
                        setEditingVoucher(pendingVoucher);
                        setFormData({
                          branch: pendingVoucher.branch || "Maradana",
                          description: pendingVoucher.description,
                          amount: pendingVoucher.amount,
                          paymentMethod: pendingVoucher.paymentMethod,
                          date: pendingVoucher.date,
                          preparedBy: pendingVoucher.preparedBy,
                          authorizedBy: pendingVoucher.authorizedBy,
                          name: pendingVoucher.name // Added name field
                        });
                        setActiveSubMenu("createVoucher");
                      } else if (pendingAction === "delete" && pendingVoucher) {
                        if (window.confirm("Are you sure you want to delete this voucher?")) {
                          try {
                            await deleteDoc(doc(db, "community_vouchers", pendingVoucher.id));
                          } catch (error) {
                            console.error("Error deleting voucher:", error);
                          }
                        }
                      }

                      // Reset modal
                      setShowPasswordModal(false);
                      setPasswordInput("");
                      setPendingAction(null);
                      setPendingVoucher(null);
                      setPendingDate("");
                    } else {
                      alert("Wrong Password!!!");
                    }
                  }}
                >
                  Confirm
                </button>
                <button
                  onClick={() => {
                    setShowPasswordModal(false);
                    setPasswordInput("");
                    setPendingDate("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="main-content">
        {activeSubMenu === 'addProject' && renderAddProject()}
        {activeSubMenu === 'createVoucher' && renderCreateVoucher()}
        {activeSubMenu === 'viewVouchers' && renderViewVouchers()}
        {activeSubMenu === 'analysis' && renderAnalysis()}
        {activeSubMenu === 'addVendor' && renderAddVendor()}
        {activeSubMenu === 'welcome' && renderWelcome()}
      </div>
    </div>
  );
}

export default AdminPanelCommunity;